// @flow

type Params = {|
    rowsCount: number,
    rowEndIndex: number,
|};

export const validateRowEndIndex = ({rowsCount, rowEndIndex}: Params): number => {
    return rowEndIndex < rowsCount ? rowEndIndex : rowsCount;
};
